<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm10>
        <h1 class="text-xs-center">Monitor Invoice</h1>
      </v-flex>
      <v-flex xs12 sm2>
        <div class="text-xs-right">
          <v-btn color="#FFD600" depressed
            ><v-icon dark left>mdi-plus-circle</v-icon>
            <h3>CREATE INVOICE</h3></v-btn
          >
        </div>
      </v-flex>
    </v-layout>
    <v-card>
      <MonitorInvoce />
    </v-card>
  </div>
</template>

<script>
import MonitorInvoce from "../../../../components/back-office/Business/Monitor-invoce.vue";
import { mapState } from "vuex";
export default {
  components: {
    MonitorInvoce,
  },
};
</script>
